import { Avatar, makeStyles } from '@material-ui/core';
import { alpha } from '@material-ui/core/styles';

import { Icon } from '@/components/shared/components/Icon';
import { StyledTooltip } from '@/components/shared/components/StyledTooltip';
import { useTranslation } from '@/components/shared/hooks/useTranslation';
import { useCustomTheme } from '@/hooks/useCustomTheme';

const AVATAR_SIZE = 20;
const CHECK_ICON_SIZE = 14;

const useStyles = makeStyles({
  avatar: {
    marginLeft: 8,
    width: AVATAR_SIZE,
    height: AVATAR_SIZE,
  },
});

export const StoredCredentialLabelSuffix = () => {
  const classes = useStyles();
  const { palette } = useCustomTheme();
  const { getTextIdTranslation } = useTranslation();

  const successColor = palette.success.main;
  const successBackgroundOpacity = palette.type === 'dark' ? 0.25 : 0.1;

  return (
    <StyledTooltip title={getTextIdTranslation('STORED_CREDENTIAL_FIELD_TOOLTIP')} tooltipProps={{ placement: 'top' }}>
      <Avatar
        className={classes.avatar}
        style={{
          backgroundColor: alpha(successColor, successBackgroundOpacity),
          color: successColor,
        }}
      >
        <Icon size={CHECK_ICON_SIZE} color={successColor}>
          check
        </Icon>
      </Avatar>
    </StyledTooltip>
  );
};
